import { render, staticRenderFns } from "./RAssessment.vue?vue&type=template&id=adeb8d3c&scoped=true"
import script from "./RAssessment.vue?vue&type=script&lang=js"
export * from "./RAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeb8d3c",
  null
  
)

export default component.exports